import { render } from "./AiAskUserBlock.vue?vue&type=template&id=04728485&scoped=true"
import script from "./AiAskUserBlock.vue?vue&type=script&lang=js"
export * from "./AiAskUserBlock.vue?vue&type=script&lang=js"

import "./AiAskUserBlock.vue?vue&type=style&index=0&id=04728485&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04728485"]])

export default __exports__